import { render, staticRenderFns } from "./Importacao.vue?vue&type=template&id=2328c892&scoped=true&"
import script from "./Importacao.vue?vue&type=script&lang=js&"
export * from "./Importacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2328c892",
  null
  
)

export default component.exports